import { Form } from "antd";
import { TextField } from "@mui/material";
import { useState } from "react";
import DocumentTitle from "react-document-title";
import { useSelector } from "react-redux";
import { generatePath, Link, useNavigate } from "react-router";
import { useCurrentUser } from "@/data/hooks";
import MobileHeader from "@/views/Components/MobileHeader";
import { RoutePaths } from "@/views/routes";
import Avatar from "boring-avatars";
import Button from "@/views/Components/Button";
import { analyticsLogEvent } from "@/data/firebase/analytics";
import { updateProfile } from "@/data/firebase/profile";
import { selectIsSignedIn } from "@/data/redux/user/selectors";
import SubHeader from "@/views/Components/SubHeader";
import BackButton from "@/views/Components/MobileHeader/BackButton";
import Spin from "@/views/Components/Spin";

interface AccountForm {
  displayName: string;
  description: string;
}

export default function Edit() {
  const isSignedIn = useSelector(selectIsSignedIn);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { user, displayName, description, profileLoaded } = useCurrentUser();
  const [form] = Form.useForm<AccountForm>();

  const onFinish = async (values: AccountForm) => {
    setLoading(true);
    if (user?.uid) {
      await updateProfile(values);
    }
    setLoading(false);
    analyticsLogEvent("account_edited");
    navigate(generatePath(RoutePaths.account));
  };

  if (!isSignedIn) {
    navigate(RoutePaths.login);
    return <></>;
  }

  if (!profileLoaded) {
    return <Spin />;
  }

  const formValues: AccountForm = { displayName, description };
  console.log("Form values", formValues);

  return (
    <DocumentTitle title="Edit profile">
      <>
        <MobileHeader title="Edit profile">
          <Button link onClick={() => form.submit()} loading={loading}>
            Save
          </Button>
          <Link to={RoutePaths.account} className="px-4">
            Cancel
          </Link>
        </MobileHeader>
        <SubHeader>
          <div className="flex justify-start">
            <BackButton link={RoutePaths.account} />
            <div className="h-5"></div>
          </div>
        </SubHeader>
        <div className="flex flex-col items-center gap-8 p-8 text-center">
          <div className="wish-bg-light-blue w-min rounded-full p-3">
            <Avatar name={user?.uid || ""} size={88} variant={"beam"} />
          </div>

          <Form
            initialValues={formValues}
            onFinish={onFinish}
            disabled={loading}
            form={form}
          >
            <Form.Item<AccountForm>
              name="displayName"
              rules={[{ required: true }]}
            >
              <TextField className="w-72" label="Display name" />
            </Form.Item>

            <Form.Item<AccountForm> name="description">
              <TextField
                className="w-72"
                label="About you"
                helperText="This text will be visible on your wishlist page"
                multiline
                rows={4}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                shape="round"
                size={"large"}
                block
                htmlType="submit"
                loading={loading}
                className="hidden! md:inline-flex!"
                full
              >
                Save
              </Button>
            </Form.Item>
          </Form>
        </div>
      </>
    </DocumentTitle>
  );
}
